import Vue from 'vue';
import Component from 'vue-class-component';
import CustomCheckboxOff from '../../components/icon/checkbox/CustomCheckboxOff.vue';
import CustomCheckboxOn from '../../components/icon/checkbox/CustomCheckboxOn.vue';
import CustomCheckboxIndeterminate from '../../components/icon/checkbox/CustomCheckboxIndeterminate.vue';
import CustomRadioOn from '../../components/icon/radio/CustomRadioOn.vue';
import CustomRadioOff from '../../components/icon/radio/CustomRadioOff.vue';
/* 
	TODO: (icon)
	1. replace string to const
	2. change mdi-icon to remix-icon
*/

export const accountCircleIcon = 'ri-account-circle-line';
export const addIcon = 'ri-add-line';
export const arrowDropDownIcon = 'ri-arrow-drop-down-line';
export const arrowDropRightIcon = 'ri-arrow-drop-right-line';
export const arrowDropUpIcon = 'ri-arrow-drop-up-line';
export const arrowLeftIcon = 'ri-arrow-left-s-line';
export const arrowRightIcon = 'ri-arrow-right-s-line';
export const artboardIcon = 'ri-artboard-line';
export const attachmentIcon = 'ri-attachment-line';
export const barChartIcon = 'ri-bar-chart-2-line';
export const briefcaseIcon = 'ri-briefcase-2-line';
export const calendarIcon = 'ri-calendar-event-line';
export const checkboxCircleIcon = 'ri-checkbox-circle-line';
export const checkIcon = 'ri-check-line';
export const closeCircleIcon = 'ri-close-circle-line';
export const riCloseIcon = 'ri-close-line';
export const coinsIcon = 'ri-coins-line';
export const couponIcon = 'ri-coupon-line';
export const contactsIcon = 'ri-contacts-line';
export const deleteIcon = 'ri-delete-bin-line';
export const downloadIcon = 'ri-download-line';
export const errorWarningIcon = 'ri-error-warning-line';
export const excelIcon = 'ri-file-excel-2-line';
export const eyeIcon = 'ri-eye-line';
export const eyeCloseIcon = 'ri-eye-close-line';
export const fileAddIcon = 'ri-file-add-line';
export const fileCopyIcon = 'ri-file-copy-line';
export const fileListIcon = 'ri-file-list-3-line';
export const fileTextIcon = 'ri-file-text-line';
export const riFilterIcon = 'ri-filter-line'; //error results if renamed to filterIcon
export const folderIcon = 'ri-folder-open-line';
export const homeIcon = 'ri-home-line';
export const informationIcon = 'ri-information-line';
export const listSettingIcon = 'ri-list-settings-line';
export const mailIcon = 'ri-mail-line';
export const mapPinIcon = 'ri-map-pin-line';
export const menu2Icon = 'ri-menu-2-line';
export const menuIcon = 'ri-menu-line';
export const moreIcon = 'ri-more-2-fill';
export const editIcon = 'ri-pencil-line';
export const paymentIcon = 'ri-bank-card-line';
export const phoneIcon = 'ri-phone-line';
export const printerIcon = 'ri-printer-line';
export const qrCodeIcon = 'ri-qr-code-line';
export const qrScanIcon = 'ri-qr-scan-2-line';
export const receiptIcon = 'ri-newspaper-line';
export const refundIcon = 'ri-refund-2-line';
export const roadMapIcon = 'ri-road-map-line';
export const searchIcon = 'ri-search-2-line';
export const settingsIcon = 'ri-settings-3-line';
export const timeIcon = 'ri-time-line';
export const timerIcon = 'ri-timer-line';
export const todoIcon = 'ri-todo-line';
export const toolsIcon = 'ri-tools-fill';
export const uploadCloudIcon = 'ri-upload-cloud-2-line';
export const uploadIcon = 'ri-upload-line';
export const userAddIcon = 'ri-user-add-line';
export const userFollowIcon = 'ri-user-follow-line';
export const userGroupIcon = 'ri-group-line';
export const userIcon = 'ri-user-line';
export const userSharedIcon = 'ri-user-shared-line';
export const voidIcon = 'ri-close-line';

// TODO: Form
export const clipboardIconClass = 'ri-clipboard-line';

/* 
	declared in vuetify.ts (global icons)
*/

export const globalIcons = {
	checkboxOff: {
		component: CustomCheckboxOff, // custom imported svg (component)
	},
	checkboxOn: {
		component: CustomCheckboxOn,
	},
	checkboxIndeterminate: {
		component: CustomCheckboxIndeterminate,
	},
	radioOn: {
		component: CustomRadioOn,
	},
	radioOff: { component: CustomRadioOff },
	complete: checkIcon,
	cancel: riCloseIcon,
	close: riCloseIcon,
	delete: deleteIcon,
	clear: riCloseIcon,
	success: checkboxCircleIcon,
	info: informationIcon,
	warning: errorWarningIcon,
	error: closeCircleIcon,
	prev: arrowLeftIcon,
	next: arrowRightIcon,
	// delimiter: 'mdi-circle', // for carousel
	sort: arrowDropUpIcon,
	expand: arrowDropDownIcon,
	menu: menu2Icon,
	subgroup: arrowDropDownIcon,
	dropdown: arrowDropDownIcon,
	edit: editIcon,
	// ratingEmpty: 'mdi-star-outline',
	// ratingFull: 'mdi-star',
	// ratingHalf: 'mdi-star-half-full',
	// loading: 'mdi-cached',
	// first: 'mdi-page-first',
	// last: 'mdi-page-last',
	// unfold: 'mdi-unfold-more-horizontal',
	file: attachmentIcon,
	// plus: 'mdi-plus',
	// minus: 'mdi-minus',
};

@Component
export class IconMixin extends Vue {
	accountCircleIcon = accountCircleIcon;
	addIcon = addIcon;
	arrowDropDownIcon = arrowDropDownIcon;
	arrowDropRightIcon = arrowDropRightIcon;
	arrowDropUpIcon = arrowDropUpIcon;
	arrowLeftIcon = arrowLeftIcon;
	arrowRightIcon = arrowRightIcon;
	artboardIcon = artboardIcon;
	attachmentIcon = attachmentIcon;
	briefcaseIcon = briefcaseIcon;
	calendarIcon = calendarIcon;
	checkboxCircleIcon = checkboxCircleIcon;
	checkIcon = checkIcon;
	closeCircleIcon = closeCircleIcon;
	riCloseIcon = riCloseIcon;
	coinsIcon = coinsIcon;
	couponIcon = couponIcon;
	contactsIcon = contactsIcon;
	deleteIcon = deleteIcon;
	downloadIcon = downloadIcon;
	errorWarningIcon = errorWarningIcon;
	excelIcon = excelIcon;
	eyeIcon = eyeIcon;
	eyeCloseIcon = eyeCloseIcon;
	fileAddIcon = fileAddIcon;
	fileCopyIcon = fileCopyIcon;
	fileListIcon = fileListIcon;
	fileTextIcon = fileTextIcon;
	riFilterIcon = riFilterIcon;
	folderIcon = folderIcon;
	homeIcon = homeIcon;
	informationIcon = informationIcon;
	listSettingIcon = listSettingIcon;
	mailIcon = mailIcon;
	mapPinIcon = mapPinIcon;
	menu2Icon = menu2Icon;
	menuIcon = menuIcon;
	moreIcon = moreIcon;
	editIcon = editIcon;
	paymentIcon = paymentIcon;
	phoneIcon = phoneIcon;
	printerIcon = printerIcon;
	qrCodeIcon = qrCodeIcon;
	qrScanIcon = qrScanIcon;
	receiptIcon = receiptIcon;
	refundIcon = refundIcon;
	roadMapIcon = roadMapIcon;
	searchIcon = searchIcon;
	settingsIcon = settingsIcon;
	timeIcon = timeIcon;
	timerIcon = timerIcon;
	todoIcon = todoIcon;
	toolsIcon = toolsIcon;
	uploadCloudIcon = uploadCloudIcon;
	uploadIcon = uploadIcon;
	userAddIcon = userAddIcon;
	userFollowIcon = userFollowIcon;
	userGroupIcon = userGroupIcon;
	userIcon = userIcon;
	userSharedIcon = userSharedIcon;
	voidIcon = voidIcon;

	clipboardIconClass = clipboardIconClass;

	lightIconWText = {
		color: 'mono500',
		class: 'horizontal-gap',
		size: '20',
	};

	lightIcon = {
		color: 'mono500',
		size: '20',
	};

	darkIcon = {
		color: 'mono700',
		size: '20',
	};

	smallIconWText = {
		iconColor: 'mono700',
		iconSize: '14',
		iconStyle: 'margin-top: -2px; font-weight:400 !important;',
	};

	normalIconWText = {
		color: 'mono700',
		class: 'horizontal-gap',
		size: '14',
	};

	normalIconWTextNoMargin = {
		color: 'mono700',
		size: '14',
	};

	centerInfoIcon = {
		color: 'mono700',
		size: '16',
	};

	iconRight = {
		class: 'horizontal-gap',
	};

	iconAppBarMenu = {
		class: 'horizontal-gap-end',
	};

	paymentHistoryIcon = {
		color: 'mono700',
		size: '16',
	};

	multiStepMenuIcon = {
		class: 'horizontal-gap',
		size: '20',
	};

	suffixIcon = {
		color: 'primary',
		class: 'ml-1', //speical case for trailing icon to text
		size: '16',
	};
}
